<template>
    <div>
        <div class="row justify-content-center">
            <div class="col-md-4 mb-3">
                <div class="card border-0 shadow">
                    <div class="card-body card-list">
                        <div class="card-text">
                            No of Tags
                            <h3>200</h3>
                        </div>
                        <div class="clear-fix">
                            <div class="float-right">
                                <span class="fa fa-envelope text-info"></span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>        
            <!--  -->
            <div class="col-md-4 mb-3">
                <div class="card border-0 shadow">
                    <div class="card-body card-list">
                        <div class="card-text">
                            No of Contacts
                            <h3>500</h3>
                        </div>
                        <div class="clear-fix">
                            <div class="float-right">
                                <span class="fa fa-envelope text-info"></span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        <!--  -->
            <div class="col-md-4 mb-3">
                <div class="card border-0 shadow">
                    <div class="card-body card-list">
                        <div class="card-text">
                            No
                            <h3>2000</h3>
                        </div>
                        <div class="clear-fix">
                            <div class="float-right">
                                <span class="fa fa-envelope text-info"></span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>        
        </div>
        <!--  -->
        <div class="row">
            <div class="col-md-8">
                <canvas id="myChart" width="400" height="400"></canvas>
            </div>
        </div>
    </div>
</template>

<script>
// import {Chart} from 'chart.js'
export default {
    data(){
        return{

        }
    },
    created(){
        // const ctx = document.getElementById('myChart').getContext('2d');
        //  new Chart(ctx, {
        //     type: 'bar',
        //     data: {
        //         labels: ['Red', 'Blue', 'Yellow', 'Green', 'Purple', 'Orange'],
        //         datasets: [{
        //             label: '# of Votes',
        //             data: [12, 19, 3, 5, 2, 3],
        //             backgroundColor: [
        //                 'rgba(255, 99, 132, 0.2)',
        //                 'rgba(54, 162, 235, 0.2)',
        //                 'rgba(255, 206, 86, 0.2)',
        //                 'rgba(75, 192, 192, 0.2)',
        //                 'rgba(153, 102, 255, 0.2)',
        //                 'rgba(255, 159, 64, 0.2)'
        //             ],
        //             borderColor: [
        //                 'rgba(255, 99, 132, 1)',
        //                 'rgba(54, 162, 235, 1)',
        //                 'rgba(255, 206, 86, 1)',
        //                 'rgba(75, 192, 192, 1)',
        //                 'rgba(153, 102, 255, 1)',
        //                 'rgba(255, 159, 64, 1)'
        //             ],
        //             borderWidth: 1
        //         }]
        //     },
        //     options: {
        //         scales: {
        //             y: {
        //                 beginAtZero: true
        //             }
        //         }
        //     }
        // });
    }
}
</script>
<style lang="css">
    
</style>